import { apim, aemAxiosInstance } from "@/constants/api"
import {
  GET_CITY_AND_STATE_BY_ZIPCODE,
  GLOBAL_CONFIGURATION_ENDPOINT,
  GENERIC_ERROR_MESSAGE,
} from "@/constants/"

import { store } from "@/store"

/**
 * Fetches the city and state details for the given zipcode.
 *
 * @param {string} zipcode - The zipcode to fetch address details for.
 * @return {Promise<Object>} A promise that resolves to an object containing city and state details.
 *                           Returns an empty object if an error occurs or no results are found.
 */
export const getCityAndStateByZipcode = async (zipcode = "") => {
  try {
    const response = await apim.get(
      `${GET_CITY_AND_STATE_BY_ZIPCODE}/${zipcode}`
    )
    const results = response?.data?.result || {}
    return {
      city: results?.city || [],
      state: results?.state || "",
    }
  } catch (e) {
    if (
      e?.response?.status === 400 &&
      e?.response?.data?.message ===
        "No suggestions found, possibly invalid ZIP provided"
    ) {
      return {
        city: [],
        state: "",
        error:
          e.response?.data?.message || "An error occurred while fetching data",
      }
    } else {
      throw new Error(
        e?.response?.data?.message || "An error occurred while fetching data"
      )
    }
  }
}

export const getAciPaymentErrorMessage = async (
  errorCode,
  errorKeyName = ""
) => {
  const { generic: { aciPaymentErrorMessagesPath = "" } = {} } =
    store.getState()
  try {
    const { data } = await aemAxiosInstance.get(
      GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + aciPaymentErrorMessagesPath
    )
    const { value: authorErrorMsg = "" } =
      data.find(e => e.text === errorCode) || {}

    let defaultErrorMessage = ""
    if (!authorErrorMsg) {
      const { value: configuredErrorMessage = "" } =
        data.find(e => e.text === errorKeyName) || {}
      defaultErrorMessage = configuredErrorMessage

      if (!configuredErrorMessage) {
        const { value: customMessage = "" } =
          data.find(e => e.text === "customErrorMessage") || {}
        defaultErrorMessage = customMessage
      }
    }

    return authorErrorMsg || defaultErrorMessage || GENERIC_ERROR_MESSAGE
  } catch {
    return GENERIC_ERROR_MESSAGE
  }
}
